<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import WootSnackbar from './Snackbar.vue';
import { emitter } from 'shared/helpers/mitt';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  duration: {
    type: Number,
    default: 2500,
  },
});

const { t } = useI18n();

const snackMessages = ref([]);
const snackbarContainer = ref(null);

const showPopover = () => {
  try {
    const el = snackbarContainer.value;
    if (el?.matches(':popover-open')) {
      el.hidePopover();
    }
    el?.showPopover();
  } catch (e) {
    // ignore
  }
};

// digitt: DENG-7340 — remove a toast by key, so an actionable toast can close itself on click
// (and each toast expires on its own key instead of shift()-ing whatever is oldest).
const removeSnack = key => {
  snackMessages.value = snackMessages.value.filter(snack => snack.key !== key);
};

const onNewToastMessage = ({ message: originalMessage, action }) => {
  const message = action?.usei18n ? t(originalMessage) : originalMessage;
  const duration = action?.duration || props.duration;
  const key = Date.now();

  snackMessages.value.push({ key, message, action });

  nextTick(showPopover);

  setTimeout(() => removeSnack(key), duration);
};

onMounted(() => {
  emitter.on('newToastMessage', onNewToastMessage);
});

onUnmounted(() => {
  emitter.off('newToastMessage', onNewToastMessage);
});
</script>

<template>
  <!-- digitt: DENG-7378 — anchor toasts bottom-left instead of top-center. -->
  <div
    ref="snackbarContainer"
    popover="manual"
    class="fixed top-auto bottom-4 left-4 max-w-[25rem] w-[calc(100%-2rem)] text-center bg-transparent border-0 p-0 m-0 outline-none overflow-visible"
  >
    <transition-group name="toast-fade" tag="div">
      <WootSnackbar
        v-for="snackMessage in snackMessages"
        :key="snackMessage.key"
        :message="snackMessage.message"
        :action="snackMessage.action"
        @dismiss="removeSnack(snackMessage.key)"
      />
    </transition-group>
  </div>
</template>
